import { useEffect } from 'react';
import {
  getCountRefreshPage,
  setCountRefreshPage,
} from 'common/utils/auth/countRefresgPage';

export const useRefreshPage = () => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        const storedCount = getCountRefreshPage();
        const newCount = storedCount + 1;
        setCountRefreshPage(newCount);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
};

export default useRefreshPage;
